import { Box, Toolbar, Typography } from '@mui/material'
import React from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { SupportImg } from '../../../../../assets/images'

const HelpSupport = () => {
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Help & Support'} subtitle={'Dashboard'} />
      <Box>
        <div>
          <Typography mt={4} mb={2} fontWeight={700} fontSize={'18px'}>
            Support Contact
          </Typography>
          <Typography>For Support Contact: support@chalkwide.com</Typography>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={SupportImg} alt="" width={'40%'} />
        </div>
      </Box>
    </div>
  )
}

export default HelpSupport
